import React, { Component } from "react";
import PropTypes from "prop-types";
import firebase from 'firebase/compat/app';
import "../common/firebase";
import "firebase/auth";
import Api from "./api";

const api = new Api;

class TwitterLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRequesting: false,
      isTwitterLinked: props.isTwitterLinked,
      isTwitterButtonHover: false,
    };

    this.handleTwitterLinkClick = this.handleTwitterLinkClick.bind(this);
    this.toggleTwitterButtonHover = this.toggleTwitterButtonHover.bind(this);
  }

  toggleTwitterButtonHover() {
    this.setState(prevState => ({
      isTwitterButtonHover: !prevState.isTwitterButtonHover
    }));
  }

  handleTwitterLinkClick(isTwitterLinked, event) {
    event.preventDefault();

    this.setState({isRequesting: true});

    const provider = new firebase.auth.TwitterAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((response) => {
        if (isTwitterLinked) {
          this.requestTwitterUnlink();
        } else {
          this.requestTwitterCallback(response);
        }
      }).catch(() => {
        this.setState({isRequesting: false});
      });
  }

  requestTwitterCallback(response) {
    const params = {
      uid: response.additionalUserInfo.profile.id,
      screen_name: response.additionalUserInfo.username,
      profile_image_url: response.additionalUserInfo.profile.profile_image_url_https,
      access_token: response.credential.accessToken,
      access_token_secret: response.credential.secret
    };

    api.postTwitterCallback(params).then(() => {
      this.setState(prevState => ({
        isRequesting: false,
        isTwitterLinked: !prevState.isTwitterLinked,
      }));
    }).catch(() => {
      this.setState({isRequesting: false});
    });
  }

  requestTwitterUnlink() {
    api.deleteTwitterLink().then(() => {
      this.setState(prevState => ({
        isRequesting: false,
        isTwitterLinked: !prevState.isTwitterLinked,
      }));
    }).catch(() => {
      this.setState({isRequesting: false});
    });
  }

  render () {
    const { isRequesting, isTwitterLinked, isTwitterButtonHover } = this.state;

    return (
      <div className="form-group row">
        <label className="col-6" htmlFor="twitter-link">
          <i className="fab fa-twitter pr-2" />
          Twitter
        </label>
        <div className="col-6 text-right">
          <TwitterButton
            isRequesting={isRequesting}
            isTwitterLinked={isTwitterLinked}
            isTwitterButtonHover={isTwitterButtonHover}
            toggleTwitterButtonHover={this.toggleTwitterButtonHover}
            handleTwitterLinkClick={this.handleTwitterLinkClick}
          />
        </div>
      </div>
    );
  }
}

function TwitterButton(props) {
  const { isRequesting, handleTwitterLinkClick, isTwitterLinked, isTwitterButtonHover, toggleTwitterButtonHover } = props;

  if (isRequesting == true) {
    return (<input type="button" className="btn btn-outline-secondary" value="接続中..." disabled />);
  } else {
    return (
      <input
        id="twitter-link"
        type="button"
        className={`btn ${isTwitterLinked ? "btn-primary" : "btn-outline-primary" }`}
        onClick={(event) => handleTwitterLinkClick(isTwitterLinked, event)}
        value={isTwitterLinked ? (isTwitterButtonHover ? "連携解除" : "連携済み") : "連携する"}
        onMouseEnter={toggleTwitterButtonHover}
        onMouseLeave={toggleTwitterButtonHover}
      />
    );
  }
}

TwitterLink.propTypes = {
  isTwitterLinked: PropTypes.bool.isRequired,
};

export default TwitterLink;
